import React from 'react';
import { Container, Typography, Box, Divider } from '@mui/material';
import Navbar from "./common/Navbar";
import Footer from "./common/Footer";


const PrivacyPolicy = () => {
    return (
        <>
            <Navbar />
            <Container maxWidth="md" style={{ marginTop: '6rem', marginBottom: '2rem' }}>
                <Typography variant="h4" gutterBottom>
                    Privacy Policy by Beryls Management Limited
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    June 7, 2024 <br />
                    502, Ikorodu Road, Lagos
                </Typography>

                <Box mt={4}>
                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Our Pedigree</Typography>
                    <Typography paragraph>
                        At Beryls Management Limited we provide Salary Loans, Business Loans, Assets Finance, and Online
                        Loans. As such, we treat Customer’s Personal Data as private and confidential. This Privacy Policy
                        describes what Personal Data we collect, what we do with it, and how we protect it.
                    </Typography>
                    <Typography paragraph>
                        Beryls Management Limited's registered office is at 502, Ikorodu Road, Lagos. We act as the Data
                        Processor when processing Customer’s Personal Data. Our designated Data Protection Officer can be
                        reached on his email <strong>info.beryls@gmail.com</strong>
                        and telephone number <strong>+2347052837926</strong>.
                    </Typography>
                    <Typography paragraph>
                        This policy (together with our Terms and Conditions) describes how we handle our customer’s
                        personal data. By continuing to visit our website (www.berylsfinanancials.com) the customer accepts
                        and consents to the practices described in this policy.
                    </Typography>
                </Box>

                <Divider />

                <Box mt={4}>
                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>What We Do</Typography>
                    <Typography paragraph>
                        At Beryls Management Limited we gather and process Customer’s Personal Data in accordance with
                        this privacy notice (including Our Terms and Conditions) and in compliance with the relevant data
                        protection regulation and laws. This notice provides you with the necessary information regarding
                        your rights and our obligations and explains how, why, and when we process your personal data.
                    </Typography>
                </Box>

                <Divider />

                <Box mt={4}>
                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Information That We Collect</Typography>
                    <Typography paragraph>
                        We process customer’s Personal Data to meet our legal, statutory, and contractual obligations and
                        with a view to providing customers with our products and services. We will never collect any
                        unnecessary personal data from customers and do not process their information in any way, other
                        than as specified in this notice.
                    </Typography>
                    <Typography paragraph>
                        The personal data collected includes:
                    </Typography>
                    <ul>
                        <li>Name</li>
                        <li>Date of Birth</li>
                        <li>Home Address</li>
                        <li>Personal Email</li>
                        <li>Home Telephone Numbers</li>
                        <li>Mobile Telephone Numbers</li>
                        <li>Passport Number/Driver's License Number</li>
                        <li>Sensitive Data (e.g., BVN, marital status)</li>
                    </ul>
                    <Typography paragraph>
                        Information collected is in the following manners:
                    </Typography>
                    <Typography paragraph>
                        - Online form, website, hard copy form, email, employment CVs, etc
                    </Typography>
                </Box>

                <Divider />

                <Box mt={4}>
                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Use of Customer’s Personal Data</Typography>
                    <Typography paragraph>
                        We take your privacy very seriously and will never disclose, share, or sell your data without your
                        consent, unless required to do so by law. We only retain your data for as long as is necessary and for the purpose(s) specified in this notice. Where our customers have consented to us providing them
                        with promotional offers and marketing, they are free to withdraw their consent at any time
                    </Typography>
                    <Typography paragraph>
                        Purposes and reasons for processing customer’s personal data
                    </Typography>
                    <ul>
                        <li>Beryls Management Limited collects personal data in the performance of a contract or to provide a service.
                        </li>
                        <li>Beryls Management Limited also collects and stores customer’s personal data as part of our legal or compliance obligation.</li>
                        <li>We have a legal obligation to share your personal data with regulatory bodies and credit bureaus who are credit reference agencies and provide us with financial background checks as part of our KYC obligations prior to transacting with us.</li>
                        <li>
                            We will occasionally send marketing information to our customers, where we have assessed that it
                            is beneficial to our customer and in our interests. Such information will be non-intrusive and is
                            processed on the grounds of legitimate interests.
                        </li>
                    </ul>
                </Box>

                <Divider />

                <Box mt={4}>
                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Customers' Rights</Typography>
                    <Typography paragraph>
                        Our customers have the right to access any Personal Data that we process about them and to request
                        information about:
                    </Typography>
                    <ul>
                        <li>What personal data we hold about our customers</li>
                        <li>The purposes of the processing</li>
                        <li>The categories of personal data concerned</li>
                        <li>The recipients of customer’s personal data or who it will be disclosed to</li>
                        <li>How long Beryls Management Limited intends to store customer’s personal data</li>
                        <li>If we did not collect the data directly from customers, information about the source.</li>
                    </ul>
                    <Typography paragraph>
                        If our customers believe that we hold any incomplete or inaccurate data about them, they have the
                        right to ask us to correct and/or complete the information and we will strive to correct it as quickly
                        as possible; unless there is a valid reason for not doing so, at which point they will be notified.
                    </Typography>
                    <Typography paragraph>
                        Our customers also have the right to request erasure of their personal data or to restrict processing
                        (where applicable) in accordance with the data protection laws; as well as to object to any direct
                        marketing from us; to exercise their data portability rights, and to be informed about any automated
                        decision-making we may use.
                    </Typography>
                    <Typography paragraph>
                        If Beryls Management Limited receives a request from our customers to exercise any of the above
                        rights, it may ask customers to verify their identities before acting on the request; this is to ensure
                        that their data is protected and kept secure.
                    </Typography>
                </Box>

                <Divider />

                <Box mt={4}>
                <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Sharing and Disclosing Customer’s Personal Data</Typography>
                <Typography paragraph>
                Beryls Management Limited does not share or disclose any of our customer’s Personal Data without 
                their consent, other than for the purposes specified in our notice or where there is a legal 
                requirement. Beryls Management Limited uses [a third-party/third-parties] to provide the below 
                services and business functions; however, all processors acting on our behalf only process their data 
                in accordance with instructions from us and comply fully with this privacy notice, the data protection 
                laws and any other appropriate confidentiality and security measures.
                </Typography>
            </Box>

                <Box mt={4}>
                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Safeguarding Measures</Typography>
                    <Typography paragraph>
                    Beryls Management Limited takes its customers' privacy seriously and takes every reasonable 
                    measure and precaution to protect and secure their personal data. Beryls Management Limited 
                    works hard to protect customers and customer’s information from unauthorized access, alteration, 
                    disclosure or destruction and has several layers of security measures in place, including but not 
                    limited to network security, password, Policies, SSL, TLS, encryptions, pseudonymisation, restricted 
                    access, IT authentication, firewalls, anti-virus/malware etc.
                    </Typography>
                </Box>

                <Divider />

                <Box mt={4}>
                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Transfers Outside Nigeria</Typography>
                    <Typography paragraph>
                    Personal data in Nigeria is protected by the Nigeria Data Protection Regulation (NDPR) but some 
                    other countries may not necessarily have the same high standard of protection for their citizens' 
                    personal data. Beryls Management Limited does not transfer or store any personal data outside 
                    Nigeria.
                    </Typography>
                </Box>

                <Divider />

                <Box mt={4}>
                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Duration of Customer’s Data</Typography>
                    <Typography paragraph>
                    Beryls Management Limited only retains Personal Data for as long as is necessary by regulation and 
given its strict review and retention policies in place to meet these obligations. Beryls Management 
Limited is required under Nigerian laws to keep customer’s basic personal data (name, address, 
contact details) for not more than 7 years after termination of business relationship.
                    </Typography>
                    <Typography paragraph>
                    Where our customers have consented to us using their details for direct marketing, Beryls 
                    Management Limited will keep such data until they notify us otherwise and/or withdraw their 
                    consent.
                    </Typography>
                </Box>

                <Divider />

                <Box mt={4}>
                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Sensitive Data</Typography>
                    <Typography paragraph>
                    Owing to our Legal/Regulatory obligations, Beryls Management Limited sometimes needs to process 
                    sensitive Personal Data (known as sensitive data) about its customers, to [uniquely 
                    identify/distinguish them and sometimes for regulatory reasons]. Where such information is 
                    collected, Beryls Management Limited will only request and process the minimum necessary for the 
                    specified purpose and identify a compliant legal basis for doing so.
                    </Typography>
                    <Typography paragraph>
                    Where we rely on our customer’s consent for processing sensitive data, Beryls Management Limited 
                    will obtain their explicit consent through [a signature/explicit mechanism]. Our customers can 
                    modify or withdraw consent at any time, of which Beryls Management Limited will act on 
                    immediately unless there is a legitimate or legal reason for not doing so.
                    
                    </Typography>
                </Box>

                <Divider />

                <Box mt={4}>
                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Disclosure of Customer’s Personal Data</Typography>
                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Law enforcement</Typography>
                    <Typography paragraph>
                    Under certain circumstances, we may be required to disclose your Personal Data if required to do so 
by law or in response to valid requests by public authorities (e.g., a court or a government agency).
                    </Typography>

                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Other legal requirements
                    </Typography>
                    <Typography paragraph>Beryls Management Limited may disclose her customer’s personal data in the good faith belief that 
                    such action is necessary to:
                    </Typography>
                    <ul>
                        <li>Comply with a legal obligation</li>
                        <li>Protect and defend the rights or property of the Company</li>
                        <li>Prevent or investigate possible wrongdoing in connection with the service or services we provide</li>
                        <li>Protect the personal safety of Beryls Management Limited staff or customers or the public</li>
                        <li>Protect against legal liability</li>
                    </ul>

                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Links to Other Websites
                    </Typography>
                    <Typography paragraph>Beryls Management Limited's website (gcredit.com.ng) does not contain links to other sites that are 
                    not operated by us. If, however in the future Beryls Management Limited adds third-party sites to its 
                    website so that when our customers click on a third-party link, they will be directed to that third 
                    party's site, Beryls Management Limited strongly advises our customers and other citizens to review 
                    the Privacy Policy of every site they visit
                    </Typography>
                    <Typography paragraph>
                    Beryls Management Limited has no control over and assumes no responsibility for the content, 
privacy policies, or practices of any third-party sites or services
                    </Typography>
                </Box>

                <Divider />

                <Box mt={4}>
                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Usage of Customer’s Personal Data</Typography>
                   <ol>
                        <li> Updating and enhancing Beryls Management Limited records.</li>
                        <li>Executing customers’ instructions.</li>
                        <li> Establishing customer’s identity and assessing applications.</li>
                        <li> Pricing and designing its products and services.</li>
                        <li>Administering its products and services.</li>
                        <li>Managing the company relationship with its customers.</li>
                        <li>Managing its risks</li>
                        <li>Conducting and improving its businesses and improving customer’s experience.</li>
                        <li>Reviewing credit or loan eligibility.</li>
                        <li>Preventing money laundering or terrorism financing activities.</li>
                        <li>Complying with our legal obligations and assisting government and other law enforcement agencies or regulators.</li>
                        <li>Identifying and informing customers about other products or services.</li>
                        <li>Processing applicants' job application if and when they apply for a job with us.</li>
                   </ol>
                </Box>

                <Divider />

                <Box mt={4}>
                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Information We Share</Typography>
                    <Typography paragraph>
                    Beryls Management Limited may share the information about her customers and their dealings, to the extent permitted by law, with the following Agencies and Third Parties:
                    </Typography>
                    <ul>
                        <li>Regulators/Supervisors, Government Agencies/courts - It may be necessary by law, legal process, 
                        litigation, and/or requests from public and governmental authorities within or outside your country 
                        of residence for Beryls Management Limited to disclose her customer’s personal data. Beryls 
                        Management Limited may also disclose information about her customers if it determines that for 
                        purposes of national security, law enforcement, or other issues of public importance, disclosure is 
                        necessary or appropriate.</li>
                        <li>External Auditors.</li>
                        <li> Beryls Management Limited staff.</li>
                        <li>Credit Agencies.</li>
                        <li> Correspondent banks.</li>
                    </ul>

                    <Typography paragraph>
                    We may also collect, use and exchange your information in ways and manners permitted by law.
                    </Typography>
                </Box>

                <Divider />

                <Box mt={4}>
                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Protection of Customer’s Information</Typography>
                    <Typography paragraph>
                    Beryls Management Limited takes appropriate technical and organizational measures to prevent 
                    losses, unauthorized access, misuse, modification, or disclosure of information under its control. This 
                    may include the use of encryption, access controls, and other forms of securities to ensure that your 
                    data is protected. Beryls Management Limited requires all parties including its staff and third-parties 
                    processing data on its behalf to comply with relevant policies and guidelines to ensure confidentiality 
                    and that information is protected in use, when stored and during transmission. Beryls Management 
                    Limited security controls and processes are also regularly updated to meet and exceed industry 
                    standards.
                    </Typography>
                </Box>

                <Divider />

                <Box mt={4}>
                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Permission to Market Products and Services</Typography>
                    <Typography paragraph>
                    As part of our service, we would like to give you information about products and services offered by 
                    Beryls Management Limited, which we believe may benefit you. Because your personal information 
                    is confidential, we need your consent to always share our marketing tools with you.                    
                    </Typography>
                </Box>

                <Divider />

                <Box mt={4}>
                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Changes to this Privacy Policy</Typography>
                    <Typography paragraph>
                    Beryls Management Limited may update our Privacy Policy from time to time and will notify her stakeholders of any changes by posting the new Privacy Policy on this page
                    </Typography>
                    <Typography paragraph>
                    Beryls Management Limited will let its customers know via email and/or a prominent notice on our 
                    service, prior to the change becoming effective and update the "Last updated" date at the top of this 
                    Privacy Policy.
                    </Typography>
                    <Typography paragraph>
                    Beryls Management Limited will review this Privacy Policy periodically for any changes. Changes to 
                    this Privacy Policy are effective when they are posted on this page.
                    </Typography>
                </Box>

                <Divider />

                <Box mt={4}>
                    <Typography variant="h6" sx={{fontWeight: 600}} gutterBottom>Contact Us</Typography>
                    <Typography paragraph>
                    If you have any questions about this Privacy Policy, you can contact us:
                        <br />
                        - Email: info.beryls@gmail.com
                        <br />
                        - Address: 502, Ikorodu Road, Lagos
                        <br />
                        - Telephone: 08038819024
                    </Typography>
                </Box>
            </Container>
            <Footer />
        </>
    );
};

export default PrivacyPolicy;
